import React from 'react';

import { useFeatureToggleContext } from 'FeatureConfig.context';
import {
  FullReturnShipment,
  PreprintedLabelReturnShipment,
} from './components';

interface ReturnShipmentProps {
  hasMultipleShipments: boolean;
}

export const ReturnShipment: React.FunctionComponent<ReturnShipmentProps> = ({
  hasMultipleShipments,
}) => {
  const {
    returnManagement: { enablePreprintedReturnLabel },
  } = useFeatureToggleContext();

  if (enablePreprintedReturnLabel) {
    return (
      <PreprintedLabelReturnShipment
        hasMultipleShipments={hasMultipleShipments}
      />
    );
  }

  return <FullReturnShipment hasMultipleShipments={hasMultipleShipments} />;
};
